<h2 class="page-title">
  {{title}}
</h2>
